function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Offer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "oferta",
  transform: "translate(3.000000, 0.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13,0.169999986 L5.85,0.169999986 C5.77464119,0.187979917 5.70553987,0.225985642 5.65,0.28 L1.49,4.46 C1.43598564,4.51553987 1.39797992,4.58464119 1.38,4.66 C1.38,4.66 1.38,4.66 1.38,4.66 C1.38,4.66 1.38,4.66 1.38,4.72 L1.38,15.72 C1.38,15.9630053 1.57699471,16.16 1.82,16.16 L13,16.16 C13.2446747,16.16 13.4445628,15.9646143 13.45,15.72 L13.45,0.61 C13.4445628,0.365385715 13.2446747,0.169999986 13,0.169999986 Z",
  id: "Path",
  fill: "#48A9A1",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.75,1.32 L4.75,1.32 C4.61486642,1.32033104 4.48538829,1.37428026 4.39,1.47 L0.21,5.62 C0.109235004,5.72023217 0.0548664758,5.85796578 0.06,6 L0.06,17 C0.06,17.2761424 0.283857625,17.5 0.56,17.5 L5.38,17.5 C5.65614237,17.5 5.88,17.2761424 5.88,17 C5.88,16.7238576 5.65614237,16.5 5.38,16.5 L1.06,16.5 L1.06,6.5 L4.72,6.5 C4.99390845,6.49467989 5.21467989,6.27390845 5.22,6 L5.22,2.32 L11.22,2.32 L11.22,7.77 C11.22,8.04614236 11.4438576,8.26999997 11.72,8.26999997 C11.9961424,8.26999997 12.2200008,8.04614236 12.2200008,7.77 L12.2200008,1.82 C12.2204771,1.55516137 12.0143619,1.33588991 11.75,1.32 Z M4.22,5.48 L1.77,5.48 L4.22,3 L4.22,5.48 Z",
  id: "Shape",
  fill: "#555150"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.76,9 C8.10314575,9 6.75994596,10.3431458 6.75994596,12 L6.75994596,19.45 C6.7571583,19.641889 6.86659781,19.8177739 7.04,19.9 C7.10740068,19.9364195 7.18347898,19.95371 7.26,19.95 C7.37351213,19.9537673 7.48425056,19.914473 7.57,19.84 L9.77,18.09 L12,19.8 C12.150052,19.9185759 12.3545982,19.9411705 12.5269131,19.8582041 C12.699228,19.7752377 12.8091215,19.6012461 12.81,19.41 L12.81,12 C12.8101117,11.1956112 12.4871869,10.4248732 11.913717,9.86080443 C11.340247,9.29673566 10.5642771,8.98659351 9.76,9 L9.76,9 Z M11.81,12.39 C11.6281173,13.5053578 10.5853046,14.2687111 9.46713355,14.1050104 C8.34896248,13.9413098 7.56873348,12.9110627 7.71420863,11.7903748 C7.85968378,10.6696869 8.87709227,9.87278888 10,10 C10.5528482,10.0646491 11.056365,10.3492218 11.3969202,10.7894976 C11.7374755,11.2297734 11.8863691,11.7886486 11.81,12.34 L11.81,12.39 Z",
  id: "Shape",
  fill: "#48A9A1"
})));

var SvgMarketing = function SvgMarketing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarketing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Marketing.2aeb3868.svg";
export { ForwardRef as ReactComponent };